import React from "react";
import * as Yup from "yup";
import { NewPasswordDocuments as documents } from "../documents";
import { useFormik } from "formik";
import CustomInput from "../../../InputCompo/CustomInput";
import { ParagraphComp } from "../../../ParagraphComp/ParagraphComp";
import ButtonComp from "../../../ButtonComp/ButtonComp";
import { Typography } from "@mui/material";
import Popup from "../components/Popup";
import eye from "../../../../Assets/img/Login/eye.png";

const NewPassword = ({ isOpen, onClose }) => {
  const modelSchema = Yup.object().shape(
    documents.reduce((schema, field) => {
      if (field.mandatory === 1 && field.type.toLowerCase() !== "section") {
        let validator = Yup.string().required(`${field.question} is required`);

        if (field.validation) {
          switch (field.validation.toLowerCase()) {
            case "email":
              validator = Yup.string()
                .email("Invalid email address")
                .required(`${field.question} is required`);
              break;

            default:
              break;
          }
        }

        schema[field.question_no] = validator;
      }

      return schema;
    }, {})
  );

  const formik = useFormik({
    initialValues: {
      ...documents.reduce((values, field) => {
        values[field.question_no] = "";
        return values;
      }, {}),
    },

    validationSchema: modelSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        // Convert the form data into a flat object
        const tempData = {
          ...documents.reduce((acc, field) => {
            acc[field.question_no] = values[field.question_no];
            return acc;
          }, {}),
        };

        // Merge new data with existing data
        const updatedData = {
          ...tempData,
        };
        const structuredData = {
          args: updatedData,
        };


        // Optionally, navigate to the next page or perform another action
        // await submitReg(structuredData);
      } catch (error) {
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <Popup
        isOpen={isOpen}
        onClose={onClose}
        image={eye}
        text="Set a New Password"
      >
        <Typography variant="subtitle1">Enter your new Password</Typography>
        <form action="" onSubmit={formik.handleSubmit}>
          {documents?.map((Fields) => (
            <div className="w-[500px] mb-3">
              <CustomInput
                required
                {...formik.getFieldProps(Fields.question_no)}
                name={Fields.question_no}
                label={Fields.question}
                onBlur={formik.handleBlur}
              />
              <ParagraphComp
                className="text-[red] text-[10px] px-[8px] mt-1"
                text={
                  formik.values?.[Fields.question_no] &&
                  formik.errors?.[Fields.question_no]
                }
              />
              <ParagraphComp
                className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                text={Fields.description}
              />
            </div>
          ))}
          <div className="flex justify-center pt-3">
            <ButtonComp
              type={"submit"}
              text={"Reset Password"}
              className="px-[40px] rounded-full bg-[#ED1C24] text-[white] py-[10px] leading-5"
            />
          </div>
        </form>
      </Popup>
    </>
  );
};

export default NewPassword;
